'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Dialog = require('./Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dialog2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/Dialog/index.js
 ** module id = 164
 ** module chunks = 0
 **/